import React from 'react';

const WaveBackground = () => (
  <div style={{ 
    position: 'fixed', 
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0, 
    opacity: 0.05, 
    pointerEvents: 'none' 
  }}>
    <svg 
      style={{ width: '100%', height: '100%' }} 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1440 320"
    >
      <path 
        fill="#0099ff" 
        fillOpacity="1" 
        d="M0,32L48,53.3C96,75,192,117,288,128C384,139,480,117,576,112C672,107,768,117,864,138.7C960,160,1056,192,1152,186.7C1248,181,1344,139,1392,117.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      />
    </svg>
  </div>
);

export default WaveBackground;